import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'trustHtml', standalone: true })
export class TrustHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string): SafeHtml {
    // Strip all HTML tags, (e.g. lorem <b>ipsum</b> -> lorem ipsum)
    // value = value.replace(/<.*?>/g, '');
    // Bold text between *, (e.g. lorem *ipsum* -> lorem <b>ipsum</b>)
    value = value.replace(/\*\s*([^*]*?)\s*\*/gi, '<b>$1</b>');
    // Replace new line with <br>, (e.g. lorem\nipsum -> lorem<br />ipsum)
    value = value.replace(/(?:\r\n|\r|\n)/gi, '<br />');

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
